<template>
  <div class="pt-3">
    <todos-lotes-itens v-model="resultadoTodosLotesEItens"
                       :casasDecimais="quantidadeCasasDecimais"
                       :validarLancesPor="validarLancesPor"
                       :criterioJulgamento="criterioJulgamento"/>
  </div>
</template>

<script>
import {actionTypes} from '@/core/constants'
import TodosLotesItens from '@/views/pages/commons/detalhe-compra-direta/resultado/TodosLotesItens.vue'
import {mapState} from 'vuex'
export default {
    name: 'ResultadoFinal',
    components: {
        TodosLotesItens
    },
    data() {
        return {
            compraDiretaId: null,
            resultadoTodosLotesEItens: [],
        }
    },
    computed: {
        ...mapState(['compraDireta', 'itensELotes']),
        quantidadeCasasDecimais() {
            if (this.compraDireta.tipo === 'COM_DISPUTA' && this.compraDireta.disputaPor === 'UNITARIO') {
                return this.compraDireta.quantidadeCasasDecimaisCompraDireta || 2
            }
            return 2
        },
        criterioJulgamento(){
            return this.compraDireta.criterioJulgamento
        },
        validarLancesPor(){
            return this.compraDireta.validarIntervaloLancesPor
        },

    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarItensELotes()
            await this.buscarResultadoTodosLotesEItens()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarItensELotes() {
            await this.$store.dispatch(actionTypes.BUSCAR_ITENS_E_LOTES, this.compraDiretaId)
        },
        async buscarResultadoTodosLotesEItens() {
            const response = await this.$store.dispatch(actionTypes.BUSCAR_RESULTADO_DE_TODOS_LOTES_E_ITENS, this.compraDiretaId)
            
            // Relacionar dados do resultado com os dados de itens e lotes
            const resultadoComItens = (response.itens || []).map(item => {
                if (item.tipo === 'LOTE') {
                    // Buscar o lote correspondente nos dados de itensELotes
                    if (this.itensELotes && this.itensELotes.lotes) {
                        const loteCompleto = this.itensELotes.lotes.find(lote => lote.descricao === item.loteItem)
                        if (loteCompleto && loteCompleto.itens) {
                            item.itens = loteCompleto.itens
                        }
                    }
                }
                return item
            })
            
            this.resultadoTodosLotesEItens = resultadoComItens
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        }
    }
}
</script>

<style scoped lang="stylus">

</style>